export const appRoutes = {
	createTrip: 'create-trip',
	teamEvents: 'team-events',
};
